import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Flip, toast, Zoom } from "react-toastify";
import { getCustomersList, postCustomers, putCustomers } from "../api/customersAPI";
import { getOrderItemsList, getOrdersList, postOrders, putOrders } from "../api/ordersAPI";

const initialState = {
  payload: {
    status: null,
    error: null,
    data: null,
  },
  post: {
    status: null,
    error: null,
    data: null,
  },
  put: {
    status: null,
    error: null,
    data: null,
  },
  get: {
    status: null,
    error: null,
    list: [],
  },
  items: {
    status: null,
    error: null,
    list: [],
  },
};

export const getOrders = createAsyncThunk("customer/getOrders", async (payload, { rejectWithValue }) => {
  try {
    const response = await getOrdersList(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});

export const getOrderItems = createAsyncThunk("customer/getOrderItems", async (payload, { rejectWithValue }) => {
  try {
    const response = await getOrderItemsList(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});

export const addOrder = createAsyncThunk(
  "customers/addOrder",
  async (payload, { rejectWithValue }) => {
    try {
      // const response = {
      //   status:201,
      //   data:{}
      // }
      const response = await postOrders(payload);
      return response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "customers/updateOrder",
  async (payload, { rejectWithValue }) => {
    try {
      // const response = {
      //   status:201,
      //   data:{}
      // }
      const response = await putOrders(payload);
      return response;
    } catch (err) {
      // console.log('err',err)
      return rejectWithValue(err.message);
    }
  }
);


export const ordersSlice = createSlice({
  name: "orders",
  initialState: initialState,
  reducers: {
    resetOrdersState: (state) => {
      state.post.status = null;
      state.post.data = null;
      state.post.error = null;

      state.payload.data = null;
      state.payload.error = null;
      state.payload.status = null;

      state.put.error = null;
      state.put.data = null;

      state.get.status = null;
      state.get.error = null;
      state.get.list = [];

      state.items.status = null;
      state.items.error = null;
      state.items.list = [];
    },
  },
  extraReducers: {
    [getOrders.pending]: (state) => {
      state.get.status = "loading";
    },
    [getOrders.fulfilled]: (state, {payload}) => {
      //console.log('actionaction',payload.data)
      const { status, data } = payload;
      if (status === 200) {
        state.get.list = data;
        state.get.error = null;
      }else{
        state.get.error = { message: `${status} - An error occurred` };
      }
      state.get.status = 'idle';
    },
    [getOrderItems.pending]: (state) => {
      state.items.status = "loading";
    },
    [getOrderItems.fulfilled]: (state, {payload}) => {
      //console.log('actionaction',payload.data)
      const { status, data } = payload;
      if (status === 200) {
        state.items.list = data;
        state.items.error = null;
      }else{
        state.items.error = { message: `${status} - An error occurred` };
      }
      state.items.status = 'idle';
    },
    [addOrder.pending]: (state) => {
      state.post.status = "loading";
    },
    [addOrder.fulfilled]: (state, { payload }) => {
      const { status, data } = payload;
     if (status === 201) {
        toast.success("Order saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
      }else{
        toast.warn("Couldn't add order!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.post.status = "idle";
      state.post.data = data;
    },
    [addOrder.rejected]: (state, action) => {
      state.post.status = "idle";
      state.post.error = { message: "An error occurred" };
      console.log("***** WORKFLOW ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't add order!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    [updateOrder.pending]: (state) => {
      state.put.status = "loading";
    },
    [updateOrder.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 202) {
        toast.success("Order updated.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
      }else{
        toast.warn("Couldn't update order!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.put.status = "idle";
      // const index = state.findIndex((user) => user.id === action.payload.id);
      // state[index].updated = action.payload.updated;
    },
    [updateOrder.rejected]: (state, action) => {
      state.put.status = "idle";
      state.put.error = { message: "An error occurred" };
      console.log("***** WORKFLOW ERROR PAYLOAD ******* ", action);
      //alert(JSON.stringify(action.error))
      toast.warn(action.error.message, {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
  },
});

//export const { resetItemsState } = resetItemsState.actions;
export default ordersSlice.reducer;
